<p-drawer [(visible)]="visible" position="right" [modal]="true" [closable]="false" [dismissible]="true"
  [style]="{ width: 'min(95vw, 850px)' }" styleClass="ocorrencia-detail-dialog efetivo-drawer-dark" (onHide)="onHide()">
  <!-- Custom Header -->
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="header-title">
        <i class="ri-alert-line header-icon"></i>
        <div>
          <h2>Detalhes da Ocorrência</h2>
          <p class="header-subtitle">
            ID #{{ occurrence?.id }} • {{ getTipoLabel(occurrence?.tipoOcorrencia || '') }}
          </p>
        </div>
      </div>
      <button type="button" class="close-btn" (click)="close()" aria-label="Fechar">
        <i class="ri-close-line"></i>
      </button>
    </div>
  </ng-template>

  <!-- Content Section -->
  <div class="dialog-content" *ngIf="occurrence">
    <div class="content-grid">
      <!-- Left Column: Details -->
      <div class="details-section">
        <!-- Criticidade & Tipo -->
        <div class="badge-section">
          <p-tag [value]="occurrence.criticidade" [severity]="getCriticidadeSeverity(occurrence.criticidade)"
            [rounded]="true" class="criticidade-tag">
          </p-tag>
          <p-tag *ngIf="occurrence.estado" [value]="getEstadoLabel(occurrence.estado)"
            [severity]="getEstadoSeverity(occurrence.estado)" [rounded]="true" class="estado-tag">
          </p-tag>
          <div class="tipo-badge">
            <i [class]="getTipoIcon(occurrence.tipoOcorrencia)"></i>
            <span>{{ getTipoLabel(occurrence.tipoOcorrencia) }}</span>
          </div>
        </div>

        <!-- Cronologia -->
        <div class="data-group">
          <h4 class="group-title"><i class="ri-time-line"></i> Cronologia</h4>
          <div class="group-grid cols-3">
            <div class="data-item">
              <span class="d-label">Ocorrência Registada</span>
              <span class="d-value fw-600">{{ occurrence.dataOcorrencia | date: "dd/MM/yyyy HH:mm" }}</span>
            </div>
            <div class="data-item">
              <span class="d-label">Início da Ronda</span>
              <span class="d-value">{{ occurrence.rondaDataInicio | date: "dd/MM/yyyy HH:mm" }}</span>
            </div>
            <div class="data-item">
              <span class="d-label">Fim da Ronda</span>
              <span class="d-value">{{ occurrence.rondaDataFim ? (occurrence.rondaDataFim | date: "dd/MM/yyyy HH:mm") :
                "Em curso" }}</span>
            </div>
          </div>
        </div>

        <!-- Envolvidos e Local -->
        <div class="data-group">
          <h4 class="group-title"><i class="ri-map-pin-user-line"></i> Local & Envolvidos</h4>
          <div class="group-grid cols-2">
            <div class="data-item">
              <span class="d-label">Posto de Serviço</span>
              <span class="d-value fw-600">
                <i class="ri-map-pin-2-line" style="margin-right: 4px; opacity: 0.7;"></i>
                {{ occurrence.nomePosto }}
              </span>
            </div>
            <div class="data-item">
              <span class="d-label">Efetivo / Equipa</span>
              <span class="d-value fw-600">
                <i class="ri-user-3-line" style="margin-right: 4px; opacity: 0.7;"></i>
                {{ occurrence.nomeEfetivo }}
              </span>
            </div>
          </div>
        </div>

        <!-- Descrição Adicional -->
        <div class="data-group description-group" *ngIf="occurrence.descricaoTipoOutro">
          <h4 class="group-title"><i class="ri-file-text-line"></i> Descrição Adicional</h4>
          <div class="description-box">
            {{ occurrence.descricaoTipoOutro }}
          </div>
        </div>

        <!-- Metadados -->
        <div class="data-group">
          <h4 class="group-title"><i class="ri-links-line"></i> Referências</h4>
          <div class="group-grid cols-2">
            <div class="data-item">
              <span class="d-label">Ronda</span>
              <span class="d-value">#{{ occurrence.rondaId }}</span>
            </div>
            <div class="data-item">
              <span class="d-label">Escala</span>
              <span class="d-value">#{{ occurrence.idEscala }}</span>
            </div>
          </div>
        </div>

        <!-- Resolução -->
        <div class="data-group" *ngIf="occurrence.estadoEnum === 2 || occurrence.dataResolucao || occurrence.desfechoDescricao">
          <h4 class="group-title"><i class="ri-checkbox-circle-line"></i> Resolução</h4>
          <div class="group-grid cols-2">
            <div class="data-item">
              <span class="d-label">Desfecho</span>
              <span class="d-value fw-600">{{ getDesfechoLabel(occurrence.desfecho) || '-' }}</span>
            </div>
            <div class="data-item">
              <span class="d-label">Data e hora da resolução</span>
              <span class="d-value">{{ occurrence.dataResolucao ? (occurrence.dataResolucao | date: 'dd/MM/yyyy HH:mm') : '-' }}</span>
            </div>
            <div class="data-item">
              <span class="d-label">Resolvido por</span>
              <span class="d-value">{{ occurrence.resolvidoPor || '-' }}</span>
            </div>
            <div class="data-item">
              <span class="d-label">Tempo até à resolução</span>
              <span class="d-value">{{ formatTempoResolucao(occurrence.tempoAteResolucaoMinutos) }}</span>
            </div>
          </div>
          <div class="data-item" *ngIf="occurrence.acoesTomadas">
            <span class="d-label">Acções tomadas</span>
            <span class="d-value">{{ occurrence.acoesTomadas }}</span>
          </div>
          <div class="data-item" *ngIf="occurrence.entidadesAccionadas">
            <span class="d-label">Entidades accionadas</span>
            <span class="d-value">{{ occurrence.entidadesAccionadas }}</span>
          </div>
          <div class="group-grid cols-2" *ngIf="occurrence.valorDanosPerdas !== null && occurrence.valorDanosPerdas !== undefined || occurrence.descricaoDanosPerdas">
            <div class="data-item">
              <span class="d-label">Valor dos danos/perdas (Kz)</span>
              <span class="d-value">{{ occurrence.valorDanosPerdas !== null && occurrence.valorDanosPerdas !== undefined ? (occurrence.valorDanosPerdas | number:'1.2-2') : '-' }}</span>
            </div>
            <div class="data-item">
              <span class="d-label">Descrição dos danos/perdas</span>
              <span class="d-value">{{ occurrence.descricaoDanosPerdas || '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column: Images Gallery -->
      <div class="images-section">
        <div class="gallery-header">
          <div class="gallery-title-wrapper">
            <i class="ri-image-line"></i>
            <h3>Anexos</h3>
          </div>
          <span class="image-count">{{ occurrence.anexos.length || 0 }} imagem(ens)</span>
        </div>

        <div class="gallery-grid" *ngIf="
            occurrence.anexos && occurrence.anexos.length > 0;
            else noImages
          ">
          <div *ngFor="let img of occurrence.anexos; trackBy: trackByImageId" class="image-card"
            [class.broken]="brokenImageIds.has(img.id)"
            (click)="!brokenImageIds.has(img.id) && openImage(img.urlImagem)">
            <div class="image-wrapper">
              <ng-container *ngIf="!brokenImageIds.has(img.id); else brokenImg">
                <img [src]="img.urlImagem" [alt]="'Anexo ' + img.id" loading="lazy" (error)="onImageError(img.id)" />
                <div class="image-overlay">
                  <i class="ri-eye-line"></i>
                  <span>Visualizar</span>
                </div>
              </ng-container>
              <ng-template #brokenImg>
                <div class="image-broken">
                  <i class="ri-image-off-line"></i>
                  <span>Imagem indisponível</span>
                </div>
              </ng-template>
            </div>
            <div class="image-footer">
              <i class="ri-attachment-line"></i>
              <span>Anexo #{{ img.id }}</span>
            </div>
          </div>
        </div>
        <ng-template #noImages>
          <div class="no-images">
            <i class="ri-image-off-line"></i>
            <p>Nenhuma imagem anexada a esta ocorrência</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button type="button" class="btn-web-secondary" (click)="close()">Fechar</button>
      <button type="button" class="btn-web-primary" *ngIf="podeFechar && occurrence?.estadoEnum !== 2" (click)="onFechar()">
        <i class="pi pi-check"></i>
        <span>Fechar ocorrência</span>
      </button>
      <button type="button" class="btn-web-secondary" *ngIf="podeReabrir && occurrence?.estadoEnum === 2" (click)="onReabrir()">
        <i class="pi pi-refresh"></i>
        <span>Reabrir ocorrência</span>
      </button>
    </div>
  </ng-template>
</p-drawer>